var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSsoAppsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#8B909A",
    strokeWidth: 0.85,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.391 1h4.174a1.39 1.39 0 0 1 1.392 1.391v4.174a1.39 1.39 0 0 1-1.392 1.392H2.391A1.39 1.39 0 0 1 1 6.565V2.391A1.39 1.39 0 0 1 2.391 1zM1 3.087h6.957M11.435 1h4.174A1.39 1.39 0 0 1 17 2.391v4.174a1.39 1.39 0 0 1-1.391 1.392h-4.174a1.39 1.39 0 0 1-1.392-1.392V2.391A1.39 1.39 0 0 1 11.435 1zM17 3.087h-6.957M2.391 10.043h4.174a1.39 1.39 0 0 1 1.392 1.392v4.174A1.39 1.39 0 0 1 6.565 17H2.391A1.39 1.39 0 0 1 1 15.609v-4.174a1.39 1.39 0 0 1 1.391-1.392zM1 12.13h6.957M11.435 10.043h4.174A1.39 1.39 0 0 1 17 11.435v4.174A1.39 1.39 0 0 1 15.609 17h-4.174a1.39 1.39 0 0 1-1.392-1.391v-4.174a1.39 1.39 0 0 1 1.392-1.392zM17 12.13h-6.957"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSsoAppsIcon);
export default __webpack_public_path__ + "static/media/sso-apps-icon.13c5f7efa6568ab299aa4332ed4f9ae2.svg";
export { ForwardRef as ReactComponent };